import React from "react";
import { Link } from "react-router-dom";
import { assetLabel, formatPrize, gameLengthLabel, metaLine } from "./leagueFormat";
import { ChevronRightIcon, PrizeTrophyIcon } from "./icons";
import LeagueStatusLine from "./LeagueStatusLine";
import HostedByQushi from "./HostedByQushi";

// An upcoming Cash Game, on the Starting soon tab of the Cash Games View All
// screen.
//
// Client: "For the cash games 'Starting soon' screen, we will also use a card
// instead of the divider line." That is the third and last tab to leave the
// divided row list, so the whole screen is cards now.
//
// Built as the Live now card's sibling on purpose — same shell, same header
// shape, same panel, same CTA — so moving between the three tabs reads as one
// system rather than three designs. What differs is only what an upcoming game
// has to say: no leaderboard yet, so the panel carries the prize; and no leader
// yet, so the identity line names the house.
//
// COLOURS ARE OURS. Client: "keep consistent eyebrow PRIZE POOL font/color and
// navy $100. my stitch is really off on those two." So the eyebrow is the same
// grey micro-label the Live now panel uses, and the figure is #0F172A — the navy
// every money figure in Cash Games prints. Stitch's own values for both are the
// drift being called out.
const CashGameUpcomingCard = ({ game }) => {
  const prize = formatPrize(game?.cash_prize_amount);
  const meta = metaLine(assetLabel(game), gameLengthLabel(game));

  return (
    <Link
      to={`/contest/${game?.vanity_url}`}
      className="group flex h-full flex-col gap-2.5 rounded-3xl border border-gray-100 bg-white px-5 py-4 shadow-sm transition-colors hover:border-gray-200 md:gap-4 md:rounded-[2rem] md:p-8 md:shadow-lg"
    >
      <div className="flex items-center justify-between gap-3">
        <HostedByQushi />
        <LeagueStatusLine game={game} className="mr-5" />
      </div>

      <div>
        <h3 className="font-montserrat font-extrabold text-base md:text-xl leading-tight text-[#0F172A] line-clamp-2">
          {game?.title}
        </h3>
        {meta && (
          <p className="mt-0.5 md:mt-1 text-xs font-medium text-secondary">{meta}</p>
        )}
      </div>

      {prize && (
        <div className="flex items-center justify-between gap-3 rounded-xl border border-gray-100 bg-[#F9FAFB] p-3 md:rounded-2xl md:p-4">
          <div className="min-w-0">
            <span className="text-[10px] font-semibold uppercase tracking-wider text-secondary md:font-bold md:text-tertiary">
              Prize pool
            </span>
            <div className="mt-0.5 font-bold text-xl md:text-3xl md:font-black leading-none text-[#0F172A]">
              {prize}
            </div>
          </div>
          <PrizeTrophyIcon className="h-6 w-6 shrink-0 md:h-7 md:w-7" fill="#006565" />
        </div>
      )}

      <div className="mt-auto flex justify-end pt-1">
        <span className="inline-flex items-center gap-1 text-sm md:text-base font-semibold text-[#004C50]">
          View Game
          <ChevronRightIcon className="h-4 w-4 md:h-5 md:w-5" />
        </span>
      </div>
    </Link>
  );
};

export default CashGameUpcomingCard;
